import React from 'react';

import {
  Card,
  CardContent,
  IconButton,
  Stack,
  StackProps,
  Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';

import {
  ISubTopicContent,
  getSubTopicState,
} from '../../../../store/SubTopicSlice';
import { useAppSelector } from '../../../../hooks';

interface ContentCardProps {
  data: ISubTopicContent;
  onDelete: () => void;
  onUpdate: () => void;
}

const cardStyles: React.CSSProperties = {
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: '#ededed',
  width: 'calc(100%)',
  borderRadius: '12px',
};

const stackProps: StackProps = {
  direction: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  style: { width: '20%', maxWidth: '20%' },
};

const ContentCard: React.FC<ContentCardProps> = ({
  data,
  onDelete,
  onUpdate,
}) => {
  // Store
  const subTopicState = useAppSelector(getSubTopicState);

  const isActionsDisabled = subTopicState.status === 'loading';
  const createdAt = moment(data.createdAt).format('DD MMM YYYY hh:mm A');

  return (
    <>
      <Stack direction="row" alignItems="center">
        <Card elevation={0} style={cardStyles}>
          <CardContent style={{ padding: '16px' }}>
            <Stack
              direction="row"
              alignItems="center"
              style={{ width: '100%' }}
            >
              <Stack
                style={{
                  width: 'calc(50% - 10px)',
                  maxWidth: 'calc(50% - 10px)',
                  paddingRight: '10px',
                }}
              >
                <div
                  className="view ql-editor ql-viewer"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: data.details,
                  }}
                />
              </Stack>
              <div style={{ width: '30%', maxWidth: '30%' }}>
                <Typography
                  color="secondary"
                  title={createdAt}
                  fontWeight={500}
                >
                  {createdAt}
                </Typography>
              </div>
              <Stack {...stackProps}>
                <IconButton
                  color="secondary"
                  onClick={onUpdate}
                  style={{ marginRight: '10px' }}
                  disabled={isActionsDisabled}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  color="error"
                  onClick={onDelete}
                  disabled={isActionsDisabled}
                >
                  <DeleteIcon />
                </IconButton>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
    </>
  );
};

export default ContentCard;
